import { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import useAppStore from '../../store/app.store';
import toast from 'react-hot-toast';

const DIAS_SEMANA = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];

const PRIORIDADE_COR = {
  urgente: '#EF4444',
  alta:    '#F97316',
  media:   '#6C4CF5',
  baixa:   '#22C55E',
};

const FREQUENCIA_LABEL = {
  diaria:     'Diária',
  semanal:    'Semanal',
  quinzenal:  'Quinzenal',
  mensal:     'Mensal',
};

function quandoExecuta(rec) {
  if (rec.frequencia === 'diaria') return 'Todo dia';
  if (rec.frequencia === 'semanal' || rec.frequencia === 'quinzenal') {
    const dia = DIAS_SEMANA[rec.dia_semana] || '';
    return `Toda ${dia}`;
  }
  if (rec.frequencia === 'mensal') return `Todo dia ${rec.dia_mes}`;
  return '—';
}

const inputStyle = {
  width: '100%',
  background: '#131D31',
  border: '1px solid #243356',
  borderRadius: 10,
  padding: '10px 12px',
  color: '#E2E8F0',
  fontSize: 14,
  outline: 'none',
  boxSizing: 'border-box',
};

const labelStyle = {
  fontSize: 12,
  color: '#94A3B8',
  display: 'block',
  marginBottom: 6,
  fontWeight: 500,
};

function Modal({ open, onClose, title, children }) {
  if (!open) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.65)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16,
    }} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{
        background: '#19243A',
        border: '1px solid #243356',
        borderRadius: 16,
        padding: 28,
        width: '100%',
        maxWidth: 500,
        maxHeight: '90vh',
        overflowY: 'auto',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 style={{ fontSize: 17, fontWeight: 700, color: '#E2E8F0', margin: 0 }}>{title}</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 20, lineHeight: 1 }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function FormRecorrente({ initial, onSalvar, onFechar, salvando }) {
  const FORM_DEFAULT = {
    titulo: '', descricao: '', frequencia: 'semanal', dia_semana: 1,
    dia_mes: 1, prioridade: 'media', setor: 'design', prazo_horas: 24,
    responsavel_id: '', cliente_id: '',
  };
  const [form, setForm] = useState(initial ? { ...FORM_DEFAULT, ...initial } : FORM_DEFAULT);
  const [clientes, setClientes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    api.get('/clientes/lista').then(r => setClientes(r.data || [])).catch(() => {});
    api.get('/usuarios/equipe').then(r => setUsuarios(r.data || [])).catch(() => {});
  }, []);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  return (
    <form onSubmit={e => { e.preventDefault(); onSalvar(form); }} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div>
        <label style={labelStyle}>Título *</label>
        <input style={inputStyle} value={form.titulo} onChange={e => set('titulo', e.target.value)} required />
      </div>
      <div>
        <label style={labelStyle}>Descrição</label>
        <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: 72 }} value={form.descricao} onChange={e => set('descricao', e.target.value)} />
      </div>
      <div>
        <label style={labelStyle}>Frequência</label>
        <select style={inputStyle} value={form.frequencia} onChange={e => set('frequencia', e.target.value)}>
          <option value="diaria">Diária</option>
          <option value="semanal">Semanal</option>
          <option value="quinzenal">Quinzenal</option>
          <option value="mensal">Mensal</option>
        </select>
      </div>
      {(form.frequencia === 'semanal' || form.frequencia === 'quinzenal') && (
        <div>
          <label style={labelStyle}>Dia da semana</label>
          <select style={inputStyle} value={form.dia_semana} onChange={e => set('dia_semana', parseInt(e.target.value))}>
            {DIAS_SEMANA.map((d, i) => <option key={i} value={i}>{d}</option>)}
          </select>
        </div>
      )}
      {form.frequencia === 'mensal' && (
        <div>
          <label style={labelStyle}>Dia do mês</label>
          <input type="number" min="1" max="31" style={inputStyle} value={form.dia_mes} onChange={e => set('dia_mes', parseInt(e.target.value))} />
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <div>
          <label style={labelStyle}>Prioridade</label>
          <select style={inputStyle} value={form.prioridade} onChange={e => set('prioridade', e.target.value)}>
            <option value="baixa">Baixa</option>
            <option value="media">Média</option>
            <option value="alta">Alta</option>
            <option value="urgente">Urgente</option>
          </select>
        </div>
        <div>
          <label style={labelStyle}>Prazo (horas após criação)</label>
          <input type="number" min="1" style={inputStyle} value={form.prazo_horas} onChange={e => set('prazo_horas', parseInt(e.target.value))} />
        </div>
      </div>
      <div>
        <label style={labelStyle}>Setor</label>
        <select style={inputStyle} value={form.setor} onChange={e => set('setor', e.target.value)}>
          <option value="design">Design</option>
          <option value="copy">Copy</option>
          <option value="trafego">Tráfego</option>
          <option value="social">Social</option>
          <option value="reuniao">Reunião</option>
          <option value="financeiro">Financeiro</option>
          <option value="administrativo">Administrativo</option>
        </select>
      </div>
      <div>
        <label style={labelStyle}>Responsável</label>
        <select style={inputStyle} value={form.responsavel_id} onChange={e => set('responsavel_id', e.target.value)}>
          <option value="">Não atribuído</option>
          {usuarios.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
        </select>
      </div>
      <div>
        <label style={labelStyle}>Cliente</label>
        <select style={inputStyle} value={form.cliente_id} onChange={e => set('cliente_id', e.target.value)}>
          <option value="">Sem cliente</option>
          {clientes.map(c => <option key={c.id} value={c.id}>{c.nome_fantasia || c.razao_social}</option>)}
        </select>
      </div>
      <div style={{ display: 'flex', gap: 10, paddingTop: 4 }}>
        <button type="submit" disabled={salvando} style={{
          flex: 1, background: '#6C4CF5', border: 'none', color: '#fff',
          borderRadius: 10, padding: '11px 0', fontWeight: 700, fontSize: 14, cursor: salvando ? 'not-allowed' : 'pointer',
          opacity: salvando ? 0.7 : 1,
        }}>
          {salvando ? 'Salvando...' : 'Salvar'}
        </button>
        <button type="button" onClick={onFechar} style={{
          background: '#131D31', border: '1px solid #243356', color: '#94A3B8',
          borderRadius: 10, padding: '11px 20px', fontWeight: 600, fontSize: 14, cursor: 'pointer',
        }}>
          Cancelar
        </button>
      </div>
    </form>
  );
}

export default function Recorrentes() {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [executando, setExecutando] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editando, setEditando] = useState(null); // null = criar, objeto = editar

  const carregar = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/recorrentes');
      setLista(data || []);
    } catch {
      toast.error('Erro ao carregar tarefas recorrentes.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const abrirCriar = () => { setEditando(null); setModalOpen(true); };
  const abrirEditar = (rec) => { setEditando(rec); setModalOpen(true); };
  const fecharModal = () => { setModalOpen(false); setEditando(null); };

  const salvar = async (form) => {
    setSalvando(true);
    try {
      if (editando) {
        await api.patch(`/recorrentes/${editando.id}`, form);
        toast.success('Tarefa atualizada!');
      } else {
        await api.post('/recorrentes', form);
        toast.success('Tarefa criada!');
      }
      fecharModal();
      carregar();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao salvar.');
    } finally {
      setSalvando(false);
    }
  };

  const toggleAtivo = async (rec) => {
    try {
      await api.patch(`/recorrentes/${rec.id}`, { ativo: !rec.ativo });
      setLista(prev => prev.map(r => r.id === rec.id ? { ...r, ativo: !r.ativo } : r));
      toast.success(rec.ativo ? 'Tarefa pausada.' : 'Tarefa ativada.');
    } catch {
      toast.error('Erro ao alterar status.');
    }
  };

  const excluir = async (rec) => {
    if (!window.confirm(`Excluir "${rec.titulo}"?`)) return;
    try {
      await api.delete(`/recorrentes/${rec.id}`);
      setLista(prev => prev.filter(r => r.id !== rec.id));
      toast.success('Tarefa excluída.');
    } catch {
      toast.error('Erro ao excluir.');
    }
  };

  const executarAgora = async () => {
    setExecutando(true);
    try {
      const { data } = await api.post('/recorrentes/executar');
      if (data.total === 0) {
        toast('Nenhum chamado gerado agora.', { icon: 'ℹ️' });
      } else {
        toast.success(`${data.total} chamado(s) criado(s)!`);
      }
      carregar();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao executar.');
    } finally {
      setExecutando(false);
    }
  };

  return (
    <div style={{ padding: '0 0 40px' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 28, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#E2E8F0', margin: 0 }}>Tarefas Recorrentes</h1>
          <p style={{ fontSize: 13, color: '#94A3B8', margin: '4px 0 0' }}>Templates que geram chamados automaticamente</p>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={executarAgora} disabled={executando} style={{
            background: '#131D31', border: '1px solid #243356', color: '#22C55E',
            borderRadius: 10, padding: '9px 16px', fontWeight: 600, fontSize: 13,
            cursor: executando ? 'not-allowed' : 'pointer', opacity: executando ? 0.7 : 1,
            display: 'flex', alignItems: 'center', gap: 6,
          }}>
            {executando ? '⏳ Executando...' : '▶ Executar agora'}
          </button>
          <button onClick={abrirCriar} style={{
            background: '#6C4CF5', border: 'none', color: '#fff',
            borderRadius: 10, padding: '9px 18px', fontWeight: 700, fontSize: 13,
            cursor: 'pointer',
          }}>
            + Nova Tarefa
          </button>
        </div>
      </div>

      {/* Lista */}
      {loading ? (
        <p style={{ color: '#64748B', textAlign: 'center', padding: 48 }}>Carregando...</p>
      ) : lista.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 64, color: '#4B5E82' }}>
          <p style={{ fontSize: 32, marginBottom: 12 }}>🔁</p>
          <p style={{ fontSize: 15, fontWeight: 600, color: '#64748B', marginBottom: 6 }}>Nenhuma tarefa recorrente</p>
          <p style={{ fontSize: 13, color: '#4B5E82' }}>Crie templates para gerar chamados automaticamente.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {lista.map(rec => (
            <div key={rec.id} style={{
              background: '#19243A',
              border: '1px solid #243356',
              borderRadius: 14,
              padding: '18px 20px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 16,
              opacity: rec.ativo ? 1 : 0.6,
            }}>
              {/* Status dot */}
              <div style={{ paddingTop: 4, flexShrink: 0 }}>
                <div style={{
                  width: 10, height: 10, borderRadius: '50%',
                  background: rec.ativo ? '#22C55E' : '#4B5E82',
                  boxShadow: rec.ativo ? '0 0 6px #22C55E88' : 'none',
                }} />
              </div>

              {/* Conteúdo */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 6 }}>
                  <span style={{ fontSize: 15, fontWeight: 700, color: '#E2E8F0' }}>{rec.titulo}</span>
                  {/* Prioridade badge */}
                  <span style={{
                    fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 6,
                    background: PRIORIDADE_COR[rec.prioridade] + '22',
                    color: PRIORIDADE_COR[rec.prioridade],
                    border: `1px solid ${PRIORIDADE_COR[rec.prioridade]}44`,
                    textTransform: 'uppercase',
                    letterSpacing: 0.5,
                  }}>{rec.prioridade}</span>
                  {/* Frequência badge */}
                  <span style={{
                    fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6,
                    background: '#6C4CF522', color: '#A78BFA',
                    border: '1px solid #6C4CF544',
                  }}>{FREQUENCIA_LABEL[rec.frequencia]}</span>
                </div>

                <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', fontSize: 12, color: '#94A3B8', marginBottom: 6 }}>
                  <span>🕐 {quandoExecuta(rec)}</span>
                  {rec.responsavel_nome && <span>👤 {rec.responsavel_nome}</span>}
                  {rec.cliente_nome && <span>🏢 {rec.cliente_nome}</span>}
                  <span>⏱ Prazo: {rec.prazo_horas}h</span>
                </div>

                <div style={{ fontSize: 11, color: '#4B5E82' }}>
                  {rec.ultima_execucao
                    ? `Última execução: ${new Date(rec.ultima_execucao).toLocaleDateString('pt-BR')}`
                    : 'Nunca executada'}
                </div>
              </div>

              {/* Ações */}
              <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                <button onClick={() => toggleAtivo(rec)} title={rec.ativo ? 'Pausar' : 'Ativar'} style={{
                  background: rec.ativo ? '#1A2744' : '#162038',
                  border: `1px solid ${rec.ativo ? '#F97316' : '#22C55E'}44`,
                  color: rec.ativo ? '#F97316' : '#22C55E',
                  borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 600,
                  cursor: 'pointer',
                }}>
                  {rec.ativo ? 'Pausar' : 'Ativar'}
                </button>
                <button onClick={() => abrirEditar(rec)} title="Editar" style={{
                  background: '#131D31', border: '1px solid #243356', color: '#94A3B8',
                  borderRadius: 8, padding: '6px 12px', fontSize: 12, cursor: 'pointer',
                }}>
                  Editar
                </button>
                <button onClick={() => excluir(rec)} title="Excluir" style={{
                  background: '#1A0B0B', border: '1px solid #EF444422', color: '#EF4444',
                  borderRadius: 8, padding: '6px 10px', fontSize: 12, cursor: 'pointer',
                }}>
                  ×
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal open={modalOpen} onClose={fecharModal} title={editando ? 'Editar Tarefa Recorrente' : 'Nova Tarefa Recorrente'}>
        <FormRecorrente
          initial={editando}
          onSalvar={salvar}
          onFechar={fecharModal}
          salvando={salvando}
        />
      </Modal>
    </div>
  );
}
